import React from 'react';

const EmptyState = ({
    icon,
    title,
    description,
    action,
    className = ""
}) => {
    return (
        <div className={`text-center py-16 ${className}`}>
            <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl">
                <div className="text-gray-400">
                    {icon}
                </div>
            </div>

            <h3 className="mb-3 text-xl font-bold text-gray-800">
                {title}
            </h3>

            {description && (
                <p className="max-w-md mx-auto mb-6 leading-relaxed text-gray-600">
                    {description}
                </p>
            )}

            {action && (
                <div className="mt-6">
                    {action}
                </div>
            )}
        </div>
    );
};

export default EmptyState;